import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { membersService } from '../api/members.service';
import { MEMBERS_KEYS } from './queryKeys';

/**
 * Removes a member from the active organization.
 * Calls DELETE /api/tenants/members/{memberId}.
 *
 * @remarks
 * On success, invalidates `MEMBERS_KEYS.byOrg` so the list reflects the removal.
 * The `owner` role and `isCurrentUser` guard is enforced in the UI —
 * the server also validates permissions independently.
 */
export function useDeleteMember() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (memberId: string) => membersService.remove(memberId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMBERS_KEYS.byOrg(orgId) });
    },
  });
}
